'use client';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { resetAccount } from '@/lib/account/accountSlice';
import { useAppDispatch } from '@/lib/hooks';
import { resetOrder } from '@/lib/order/orderSlice';

import { BusinessEmailLayout } from '../components';

const Content = () => {
  const t = useTranslations();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(resetOrder());
    dispatch(resetAccount());
  }, [dispatch]);

  return (
    <BusinessEmailLayout
      title={t('eop_login_email_page_title')}
      description={t('eop_login_email_page_description')}
    />
  );
};

export default Content;
